import { hasPermissionsOr } from '../../permission/helpers.js';
import { EnumForCommonOnlyPermissionRole, } from '../@types/index.js';
import { emailConfirmed, isApproved, isNotBanned } from '../helpers.js';
export const consoleRoutes = {
    main: {
        route: '/console',
        get: () => '/console',
        permissions: (viewer) => {
            const messages = [];
            const onFail = (message) => messages.push(message);
            let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
            if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CONSOLE_ACCESS])) {
                status = false;
                messages.push('Missing some permissions. Please contact your administrator.');
            }
            return {
                status,
                messages,
            };
        },
    },
    home: {
        main: {
            route: '/console/home',
            get: () => `/console/home`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CONSOLE_ACCESS])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        overview: {
            route: '/console/home/overview',
            get: () => `/console/home/overview`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CONSOLE_ACCESS])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    setting: {
        main: {
            route: '/console/setting',
            get: () => `/console/setting`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.ADMIN])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/setting/all',
            get: () => `/console/setting/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.ADMIN])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/setting/edit/:uuid',
            get: (uuid) => `/console/setting/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.ADMIN])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    mpaa: {
        main: {
            route: '/console/mpaa',
            get: () => `/console/mpaa`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/mpaa/all',
            get: () => `/console/mpaa/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/mpaa/new/:uuid',
            get: (uuid) => `/console/mpaa/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/mpaa/edit/:uuid',
            get: (uuid) => `/console/mpaa/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    genre: {
        main: {
            route: '/console/genre',
            get: () => `/console/genre`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/genre/all',
            get: () => `/console/genre/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/genre/new/:uuid',
            get: (uuid) => `/console/genre/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/genre/edit/:uuid',
            get: (uuid) => `/console/genre/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    region: {
        main: {
            route: '/console/region',
            get: () => `/console/region`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/region/all',
            get: () => `/console/region/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/region/new/:uuid',
            get: (uuid) => `/console/region/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/region/edit/:uuid',
            get: (uuid) => `/console/region/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    tag: {
        main: {
            route: '/console/tag',
            get: () => `/console/tag`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/tag/all',
            get: () => `/console/tag/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/tag/new/:uuid',
            get: (uuid) => `/console/tag/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/tag/edit/:uuid',
            get: (uuid) => `/console/tag/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    language: {
        main: {
            route: '/console/language',
            get: () => `/console/language`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/language/all',
            get: () => `/console/language/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/language/new/:uuid',
            get: (uuid) => `/console/language/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/language/edit/:uuid',
            get: (uuid) => `/console/language/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    crossword: {
        main: {
            route: '/console/crossword',
            get: () => `/console/crossword`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/crossword/all',
            get: () => `/console/crossword/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/crossword/banned',
            get: () => `/console/crossword/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        trash: {
            route: '/console/crossword/trash',
            get: () => `/console/crossword/trash`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/crossword/new/:uuid',
            get: (uuid) => `/console/crossword/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/crossword/edit/:uuid',
            get: (uuid) => `/console/crossword/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    crosswordSeries: {
        main: {
            route: '/console/crossword-series',
            get: () => `/console/crossword-series`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/crossword-series/all',
            get: () => `/console/crossword-series/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        homePage: {
            route: '/console/crossword-series/home-page',
            get: () => `/console/crossword-series/home-page`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        challenge: {
            route: '/console/crossword-series/challenge',
            get: () => `/console/crossword-series/challenge`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/crossword-series/new/:uuid',
            get: (uuid) => `/console/crossword-series/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/crossword-series/edit/:uuid',
            get: (uuid) => `/console/crossword-series/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    movie: {
        main: {
            route: '/console/movie',
            get: () => `/console/movie`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/movie/all',
            get: () => `/console/movie/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/movie/banned',
            get: () => `/console/movie/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        notPremiered: {
            route: '/console/movie/not-premiered',
            get: () => `/console/movie/not-premiered`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        trash: {
            route: '/console/movie/trash',
            get: () => `/console/movie/trash`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/movie/new/:uuid',
            get: (uuid) => `/console/movie/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/movie/edit/:uuid',
            get: (uuid) => `/console/movie/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    episode: {
        main: {
            route: '/console/episode',
            get: () => `/console/episode`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/episode/all',
            get: () => `/console/episode/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/episode/banned',
            get: () => `/console/episode/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        notPremiered: {
            route: '/console/episode/not-premiered',
            get: () => `/console/episode/not-premiered`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        trash: {
            route: '/console/episode/trash',
            get: () => `/console/episode/trash`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/episode/new/:uuid',
            get: (uuid) => `/console/episode/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/episode/edit/:uuid',
            get: (uuid) => `/console/episode/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    season: {
        main: {
            route: '/console/season',
            get: () => `/console/season`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/season/all',
            get: () => `/console/season/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/season/banned',
            get: () => `/console/season/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        notPremiered: {
            route: '/console/season/not-premiered',
            get: () => `/console/season/not-premiered`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        trash: {
            route: '/console/season/trash',
            get: () => `/console/season/trash`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/season/new/:uuid',
            get: (uuid) => `/console/season/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/season/edit/:uuid',
            get: (uuid) => `/console/season/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    tv: {
        main: {
            route: '/console/tv',
            get: () => `/console/tv`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/tv/all',
            get: () => `/console/tv/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/tv/banned',
            get: () => `/console/tv/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        notPremiered: {
            route: '/console/tv/not-premiered',
            get: () => `/console/tv/not-premiered`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        trash: {
            route: '/console/tv/trash',
            get: () => `/console/tv/trash`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/tv/new/:uuid',
            get: (uuid) => `/console/tv/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/tv/edit/:uuid',
            get: (uuid) => `/console/tv/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    showSeries: {
        main: {
            route: '/console/show-series',
            get: () => `/console/show-series`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/show-series/all',
            get: () => `/console/show-series/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        homePage: {
            route: '/console/show-series/home-page',
            get: () => `/console/show-series/home-page`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        tvPage: {
            route: '/console/show-series/tvs-page',
            get: () => `/console/show-series/tvs-page`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        moviesPage: {
            route: '/console/show-series/movies-page',
            get: () => `/console/show-series/movies-page`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/show-series/new/:uuid',
            get: (uuid) => `/console/show-series/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/show-series/edit/:uuid',
            get: (uuid) => `/console/show-series/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.SHOW_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    userShowPurchase: {
        main: {
            route: '/console/show-purchase',
            get: () => `/console/show-purchase`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        overview: {
            route: '/console/show-purchase/overview',
            get: () => `/console/show-purchase/overview`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/show-purchase/all',
            get: () => `/console/show-purchase/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/show-purchase/new/:uuid',
            get: (uuid) => `/console/show-purchase/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/show-purchase/edit/:uuid',
            get: (uuid) => `/console/show-purchase/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    userShowRent: {
        main: {
            route: '/console/show-rent',
            get: () => `/console/show-rent`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        overview: {
            route: '/console/show-rent/overview',
            get: () => `/console/show-rent/overview`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/show-rent/all',
            get: () => `/console/show-rent/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/show-rent/new/:uuid',
            get: (uuid) => `/console/show-rent/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/show-rent/edit/:uuid',
            get: (uuid) => `/console/show-rent/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.PURCHASE_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    user: {
        main: {
            route: '/console/user',
            get: () => `/console/user`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/user/all',
            get: () => `/console/user/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/user/new/:uuid',
            get: (uuid) => `/console/user/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/user/edit/:uuid',
            get: (uuid) => `/console/user/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        banned: {
            route: '/console/user/banned',
            get: () => `/console/user/banned`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        notApproved: {
            route: '/console/user/not-approved',
            get: () => `/console/user/not-approved`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    profile: {
        main: {
            route: '/console/profile',
            get: () => `/console/profile`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/profile/all',
            get: () => `/console/profile/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/profile/new/:uuid',
            get: (uuid) => `/console/profile/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/profile/edit/:uuid',
            get: (uuid) => `/console/profile/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.USER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    person: {
        main: {
            route: '/console/person',
            get: () => `/console/person`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/person/all',
            get: () => `/console/person/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.CROSSWORD_READ,
                    EnumForCommonOnlyPermissionRole.SHOW_READ,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/person/new/:uuid',
            get: (uuid) => `/console/person/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/person/edit/:uuid',
            get: (uuid) => `/console/person/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [
                    EnumForCommonOnlyPermissionRole.CROSSWORD_WRITE,
                    EnumForCommonOnlyPermissionRole.SHOW_WRITE,
                ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    upload: {
        main: {
            route: '/console/upload',
            get: () => `/console/upload`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/upload/all',
            get: () => `/console/upload/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        avatar: {
            route: '/console/upload/avatar',
            get: () => `/console/upload/avatar`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        image: {
            new: {
                route: '/console/upload/image/new/:uuid',
                get: (uuid) => `/console/upload/image/new/${uuid}`,
                permissions: (viewer) => {
                    const messages = [];
                    const onFail = (message) => messages.push(message);
                    let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                    if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_WRITE])) {
                        status = false;
                        messages.push('Missing some permissions. Please contact your administrator.');
                    }
                    return {
                        status,
                        messages,
                    };
                },
            },
            edit: {
                route: '/console/upload/image/edit/:uuid',
                get: (uuid) => `/console/upload/image/edit/${uuid}`,
                permissions: (viewer) => {
                    const messages = [];
                    const onFail = (message) => messages.push(message);
                    let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                    if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_WRITE])) {
                        status = false;
                        messages.push('Missing some permissions. Please contact your administrator.');
                    }
                    return {
                        status,
                        messages,
                    };
                },
            },
        },
        video: {
            new: {
                route: '/console/upload/video/new/:uuid',
                get: (uuid) => `/console/upload/video/new/${uuid}`,
                permissions: (viewer) => {
                    const messages = [];
                    const onFail = (message) => messages.push(message);
                    let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                    if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_WRITE])) {
                        status = false;
                        messages.push('Missing some permissions. Please contact your administrator.');
                    }
                    return {
                        status,
                        messages,
                    };
                },
            },
            edit: {
                route: '/console/upload/video/edit/:uuid',
                get: (uuid) => `/console/upload/video/edit/${uuid}`,
                permissions: (viewer) => {
                    const messages = [];
                    const onFail = (message) => messages.push(message);
                    let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                    if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.UPLOAD_WRITE])) {
                        status = false;
                        messages.push('Missing some permissions. Please contact your administrator.');
                    }
                    return {
                        status,
                        messages,
                    };
                },
            },
        },
    },
    permission: {
        main: {
            route: '/console/permission',
            get: () => `/console/permission`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.ADMIN])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/permission/all',
            get: () => `/console/permission/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.ADMIN])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
    creditVoucher: {
        main: {
            route: '/console/credit-voucher',
            get: () => `/console/credit-voucher`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CREDIT_VOUCHER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        all: {
            route: '/console/credit-voucher/all',
            get: () => `/console/credit-voucher/all`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CREDIT_VOUCHER_READ])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        new: {
            route: '/console/credit-voucher/new/:uuid',
            get: (uuid) => `/console/credit-voucher/new/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CREDIT_VOUCHER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
        edit: {
            route: '/console/credit-voucher/edit/:uuid',
            get: (uuid) => `/console/credit-voucher/edit/${uuid}`,
            permissions: (viewer) => {
                const messages = [];
                const onFail = (message) => messages.push(message);
                let status = isNotBanned(viewer, onFail) && isApproved(viewer, onFail) && emailConfirmed(viewer, onFail);
                if (!hasPermissionsOr(viewer.permission_roles, [EnumForCommonOnlyPermissionRole.CREDIT_VOUCHER_WRITE])) {
                    status = false;
                    messages.push('Missing some permissions. Please contact your administrator.');
                }
                return {
                    status,
                    messages,
                };
            },
        },
    },
};
//# sourceMappingURL=console.js.map